import { LOCAL_DEVELOPMENT_ACCESS_TOKEN } from './local-development-token'

export { LOCAL_DEVELOPMENT_ACCESS_TOKEN } from './local-development-token'

export function getLocalDevelopmentAccessToken() {
  if (!import.meta.env.DEV) return ''
  return LOCAL_DEVELOPMENT_ACCESS_TOKEN.trim().replace(/^Bearer\s+/i, '')
}
